<template>
    <el-container>   
      <app-main></app-main>
    </el-container>
 
</template>
<script>
import AppAside from '../app-aside'
import AppHeader from '../app-header'
import AppMain from '../app-main'
import AppFooter from '../app-footer'

export default {
  name: 'layout',
  components: {
    AppAside,
    AppHeader,
    AppMain,
  },
    data () {
        return {
            showAside:true,
        }
    },
    mounted(){
      
    }
}
</script>
<style>
  .section{
    display: flex;
    display: -webkit-flex;
    background: #F8F8F8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/views/layout/first-router/noAside.vue